import {
  getCustomSchemasUserPortal,
  getUserQuery,
  UserKeys,
} from '../../api/users-api';
import { useQuery } from '@tanstack/react-query';
import CustomSchemasForm from '../user-management/user-details/custom-schemas/custom-schemas-form';
import { useUserSettings } from '../../utils/use-user-settings';
import { Messages } from '../../utils/message-constants';
import { userPortalPagesConfig } from '../../shared/user-portal-pages-config';
import { useLocation } from 'react-router-dom';

import Box from '@mui/material/Box';
import Skeleton from '@mui/material/Skeleton';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import SharedTabHeader from '../../shared/shared-tab-header';
import SharedIconButton from '../../shared/buttons/shared-icon-button';
import SharedButton from '../../shared/buttons/shared-button';

export default function CustomAttributesPage() {
  const { userViewRoles, directoryRoles, changeLogRoles, loggedInUser } =
    useUserSettings();
  const location = useLocation();
  const userView = location.pathname.includes(
    userPortalPagesConfig.userPortal.link
  );
  const { data: user } = useQuery(getUserQuery(loggedInUser, userView));
  const {
    isLoading,
    data: fullSchemaData,
    isFetching,
  } = useQuery({
    queryKey: [UserKeys.CustomSchemas],
    queryFn: () => getCustomSchemasUserPortal(),
    meta: {
      errorMessage: Messages.Errors.Network.Loading('custom attributes'),
    },
  });

  if (!user || isLoading || isFetching) {
    return (
      <Box
        sx={{
          height: '100%',
          position: 'relative',
          p: 2,
          pt: 1,
        }}
      >
        <SharedTabHeader title="Custom Attributes" noDivider />
        <Stack
          flexDirection="row"
          justifyContent="flex-end"
          alignItems="center"
          gap={1}
          sx={{ position: 'absolute', top: 10, right: 20 }}
        >
          <SharedIconButton variant="refresh" tooltipLabel="Refresh" disabled />
          <SharedButton variant="primary" disabled>
            Save
          </SharedButton>
        </Stack>

        <Stack
          sx={{ p: 2, justifyContent: 'center', maxWidth: 1000, mx: 'auto' }}
          gap={1}
        >
          <Skeleton variant="rounded" width={'100%'} height={80} />
          <Skeleton variant="rounded" width={'100%'} height={80} />
          <Skeleton variant="rounded" width={'100%'} height={80} />
          <Skeleton variant="rounded" width={'100%'} height={80} />
          <Skeleton variant="rounded" width={'100%'} height={80} />
          <Skeleton variant="rounded" width={'100%'} height={80} />
          <Skeleton variant="rounded" width={'100%'} height={80} />
          <Skeleton variant="rounded" width={'100%'} height={80} />
          <Skeleton variant="rounded" width={'100%'} height={80} />
          <Skeleton variant="rounded" width={'100%'} height={80} />
        </Stack>
      </Box>
    );
  } else if (fullSchemaData) {
    return (
      <CustomSchemasForm
        user={user}
        fullSchemaData={fullSchemaData}
        directoryRoles={directoryRoles}
        changeLogRoles={changeLogRoles}
        userViewRoles={userViewRoles}
      />
    );
  } else {
    return (
      <Typography>
        There are no created custom attributes on this domain.
      </Typography>
    );
  }
}
